import { render, staticRenderFns } from "./WidgetPaginationLayout.vue?vue&type=template&id=3e9e5504&scoped=true&"
import script from "./WidgetPaginationLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetPaginationLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetPaginationLayout.vue?vue&type=style&index=0&id=3e9e5504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9e5504",
  null
  
)

export default component.exports